<template>
  <status-select :options="options" :record="record" record_type="unit" />
</template>

<script>
  import { unitStatuses } from 'shared/statuses'
  import StatusSelect from '../../shared/components/status-select'
  export default {
    props: [ 'record' ],
    data () {
      return { options: unitStatuses }
    },
    components: {
      StatusSelect
    }
  }
</script>
